import { useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { EuiFormLabel, EuiComboBox, EuiComboBoxOptionOption, EuiFlexGroup } from '@elastic/eui';
import { VENDOR_NAMES } from 'apollo-client/queries/getAvailableVendorNames';
import { vendorNames } from 'cache';

import { Query, QueryGetAvailableVendorNamesArgs } from 'generated/graphql';
import { FormattedMessage, useIntl } from 'react-intl';
import { useLocalCache } from 'hooks/useLocalCache';
import * as S from './vendorNameFilter.styles';
import { SelectAll } from 'components/SelectAll';

export const VendorNameFilter = (): JSX.Element => {
  const { formatMessage } = useIntl();
  const localFilters = useLocalCache();
  const [selectAll, setSelectAll] = useState(false);
  const [onGetAvailableVendorNames, { loading, data }] = useLazyQuery<Query, QueryGetAvailableVendorNamesArgs>(
    VENDOR_NAMES
  );

  return (
    <S.VendorNameFilter>
      <EuiFlexGroup>
        <EuiFormLabel>{formatMessage({ id: 'filters.vendorName.label' })}</EuiFormLabel>
        <div style={{ marginLeft: '24px' }}>
          {selectAll && (
            <SelectAll
              onClick={(): void => {
                vendorNames(data?.getAvailableVendorNames);
                setSelectAll(false);
              }}
            >
              <FormattedMessage id="filters.selectAll" defaultMessage="Seleziona Tutti" />
            </SelectAll>
          )}
        </div>
      </EuiFlexGroup>
      <EuiComboBox
        async
        isLoading={loading}
        placeholder={formatMessage({ id: 'filters.vendorName.placeholder' })}
        options={data?.getAvailableVendorNames?.map((x: string) => ({ label: x, value: x })) ?? []}
        selectedOptions={localFilters?.data?.vendorNames?.map((x: string) => ({ label: x, value: x }))}
        onSearchChange={(e: string): void => {
          e.length > 2 ? setSelectAll(true) : setSelectAll(false);
          onGetAvailableVendorNames({ variables: { inputVendorName: e } });
        }}
        onClick={(): void => {
          onGetAvailableVendorNames({ variables: { inputVendorName: '' } });
        }}
        onChange={(x: EuiComboBoxOptionOption<string>[]): void => {
          vendorNames(x?.map(({ value }) => value) as string[]);
        }}
      />
    </S.VendorNameFilter>
  );
};
